export default __webpack_public_path__ + "static/media/bg2.2191ff64.svg";